export default {
  collections: {
    academicYears: [],
    months: [],
    services: [],
    centers: [],
    disciplines: [],
    status: [],
    districts: [],
    providers: [],
    municipalities: [],
    specialists: [],
    schools: [],
  },
  filters: {
    academicYear: null,
    month: null,
    service: null,
    sieorappointment: null,
    center: null,
    discipline: null,
    district: null,
    municipality: null,
    school: null,
    status: null,
    provider: null,
    specialist: null,
    numberAppointment: null,
  },
  results: [],
  pagination: {
    currentPage: 1,
    totalItemCount: 0,
    pageCount: 1,
    count: 0,
    pageSize: 10,
  },
  centerDisabled: false,
  districtDisabled: false,
  municipalityDisabled: false,
  schoolDisabled: false,
};
